import {
  QIN_ACCESS_TOKEN_STORAGE_NAME,
  QIN_REFRESH_TOKEN_STORAGE_NAME,
} from '@/const'

export const ACCESS_TOKEN_COOKIE: string = QIN_ACCESS_TOKEN_STORAGE_NAME
export const REFRESH_TOKEN_COOKIE: string = QIN_REFRESH_TOKEN_STORAGE_NAME

export const UNAUTHORIZED = 401
export const BAD_REQUEST = 400